import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import TasktrackingTable from "@/components/tasktracking/tasktrackingTable";

const TasktrackingList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_tasktrackinglist">
      <TasktrackingTable />
    </RestrictedPage>
  );
};

export default TasktrackingList;
